import React, { useEffect, memo } from "react";
import { makeStyles } from "@mui/styles";
import { Box, Paper } from "@mui/material";
import JWPlayer from "../../sharedComponents/JWPlayer/JWPlayer";
import { Video_baseUrl } from "../../services/AzureStorage";
import novideoIcon from "../../images/videoIcon.png";
import placeholder from "../../images/video-placeholder.png";
import VideoJS from "../../sharedComponents/videoPlayer/VideoJS";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  statusHeader: {
    backgroundColor: "#fff",
    width: "600px !important",
    color: "#0000 !important",
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
    },
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
  },
  contentSection: {
    display: "flex",
    flexDirection: "column",
    padding: "25px 70px 25px 50px",
    [theme.breakpoints.up("md")]: {
      alignItems: "center",
    },
    "& .jwplayer": {
      width: "600px !important",
      height: "280px !important",
      backgroundColor: "#000000 !important",
      [theme.breakpoints.down("sm")]: {
        width: "100% !important",
      },
      [theme.breakpoints.down("md")]: {
        width: "100% !important",
      },
    },
  },
  jwtPlayerContainer: {
    border: "2px solid lightgrey",
    padding: "25px",
    borderRadius: "5px",
  },
}));

const RevisedGameContentBlock = (props) => {
  const classes = useStyles();
  return (
    <>
      {JSON.stringify(props.data) === "{}" ? (
        <Box component="div" className={classes.root}>
          <Box component="div" className={classes.contentSection}>
            <Paper elevation={2} className={classes.jwtPlayerContainer}>
              <Paper elevation={2} sx={{ border: "1px solid #808080" }}>
                <img
                  alt="no-video-selected"
                  src={placeholder}
                  className="jwplayer"
                />
              </Paper>
            </Paper>
          </Box>
        </Box>
      ) : (
        <Box component="div" className={classes.root}>
          <Box component="div" className={classes.contentSection}>
            <Paper elevation={2} className={classes.jwtPlayerContainer}>
              <VideoJS
                fileURL={`${Video_baseUrl(props.data.videoUrl)}`}
                userName={props.data.playerName}
                playExternalVideo={true}
                fileName={props.data.videoUrl}
                isSlowMo={true}
                isDownload={true}
              />
            </Paper>

            {/* <AppBar position="static" className={classes.statusHeader}>
              <Toolbar>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {props.data.playerName ? (
                    <>
                      <Avatar sx={{ bgcolor: "#1d428a" }}>
                        {props.data.playerName.split(",")[0][0]}
                        {props.data.playerName?.split(",")[1]?.substring(0, 1)}
                      </Avatar>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "column",
                          color: "black !important",
                          fontWeight: 800,
                          padding: "10px",
                        }}
                      >
                        <Typography
                          variant="h6"
                          component="div"
                          sx={{
                            marginTop: "10px",
                            typography: { sm: "body1", xs: "body2" },
                            overflowWrap: "break-word",
                            wordWrap: "break-word",
                          }}
                        >
                          {props.data.playerName} | {props.data.drillType}
                        </Typography>
                        <Typography
                          component="div"
                          variant="body2"
                          color="text.primary"
                        >
                          {Helper.FormatDateTime(
                            moment(props.data.createdDate).format(),
                            CultureInfo.GetCultureInfo().DateTimeFormat
                          )}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        <Alert sx={{ width: "100%" }} severity="info">
                          Please select video first!
                        </Alert>
                      </Box>
                    </>
                  )}
                </Box>
              </Toolbar>
            </AppBar> */}
          </Box>
        </Box>
      )}
    </>
  );
};

export default memo(RevisedGameContentBlock);
